export default "__VITE_ASSET__DTeq7o3C__"